const defaultOptions = {
  hoursToLive: null,
  path: '/',
  domain: null,
  secure: false
}

/**
 * 根据键获取cookie值
 * @param  {String} key    [键]
 */
function get (key) {
  const reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
  let arr = document.cookie.match(reg)
  if (arr) {
    return unescape(arr[2])
  } else {
    return null
  }
}

/**
 * 设置cookie
 * @param  {String}  key    [键]
 * @param  {String}  value  [值]
 */
function set (key, value, options) {
  if (typeof value === 'undefined' || value === null) {
    value = ''
  }

  if (typeof options === 'undefined' || options === null) {
    options = defaultOptions
  }

  const optionsString = assembleOptionsString(options)

  document.cookie = key + '=' + escape(value) + optionsString
}

function resolveOptions (options) {
  let returnValue

  if (typeof options !== 'object' || options === null) {
    returnValue = defaultOptions
  } else {
    returnValue = {
      hoursToLive: (typeof options.hoursToLive === 'number' && options.hoursToLive !== 0 ? options.hoursToLive : defaultOptions.hoursToLive),
      path: (typeof options.path === 'string' && options.path !== '' ? options.path : defaultOptions.path),
      domain: (typeof options.domain === 'string' && options.domain !== '' ? options.domain : defaultOptions.domain),
      secure: (typeof options.secure === 'boolean' && options.secure ? options.secure : defaultOptions.secure)
    }
  }

  return returnValue
}

function expiresGMTString (hoursToLive) {
  hoursToLive = hoursToLive || (30 * 24) // 30天
  const exp = new Date()
  exp.setTime(exp.getTime() + hoursToLive)

  return exp.toGMTString()
}

function assembleOptionsString (options) {
  options = resolveOptions(options)

  return (
    (typeof options.hoursToLive === 'number' ? '; expires=' + expiresGMTString(options.hoursToLive) : '') +
    '; path=' + options.path +
    (typeof options.domain === 'string' ? '; domain=' + options.domain : '') +
    (options.secure === true ? '; secure' : '')
  )
}

export default { get, set }



// WEBPACK FOOTER //
// ./src/assets/js/CookieUtils.js